import { type ColorToken } from '@backrs_ui/common-ui/src/designSystem/colors/colors';

export type SeriesColor = Readonly<{
  fill: ColorToken;
  // The text colour that reads on the fill.
  label: ColorToken;
}>;

/** Series colours in hand-out order; the first four are the career track colours. */
export const SERIES_COLORS: readonly SeriesColor[] = [
  { fill: 'Brand/500', label: 'Colors/Text/text-white' },
  { fill: 'Warning/400', label: 'Colors/Text/text-primary' },
  { fill: 'Error/400', label: 'Colors/Text/text-white' },
  { fill: 'Success/500', label: 'Colors/Text/text-white' },
  { fill: 'Brand/900', label: 'Colors/Text/text-white' },
  { fill: 'Brand/200', label: 'Colors/Text/text-primary' },
  { fill: 'Warning/700', label: 'Colors/Text/text-white' },
  { fill: 'Success/700', label: 'Colors/Text/text-white' },
];

/** The colour for the nth series, cycling past the end of the palette. */
export const seriesColor = (index: number): SeriesColor =>
  SERIES_COLORS[index % SERIES_COLORS.length];
